fragment MenuOverlayImageAsset on AssetInterface {
    id
    url @transform(width: 416, format: "webp")
    w813: url @transform(width: 813, format: "webp")
    w813_avif: url @transform(width: 813, format: "avif")
    w416: url @transform(width: 416, format: "webp")
    w416_avif: url @transform(width: 416, format: "avif")
    width
    height

    ... on media_Asset {
        alt
        title
    }
}
